export default __webpack_public_path__ + "static/media/Data-Warehousing.420ec268.png";